<template>
  <div class="product-page" id="page" v-cloak>
    <!-- <navbar v-show="isTop == false"></navbar> -->
    <div v-if="isTop == false" class="h-nav-item" @click="onClickLeft">
      <van-icon name="arrow-left" />
    </div>

    <van-nav-bar v-if="isTop" title="商品详情" fixed left-arrow @click-left="onClickLeft" @click-right="goHome">
      <template #right>
        <van-icon name="wap-home-o" size="18" />
      </template>
    </van-nav-bar>

    <!-- 轮播图 -->
    <van-swipe class="swiper-block" indicator-color="white">
      <van-swipe-item v-for="(item, index) in productInfo.pic_list" :key="index">
        <!-- <img class="swiper-img" :src="item" alt="" /> -->
        <van-image class="swiper-img" :src="item" @click="imagePreview(productInfo.pic_list,index)">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
      </van-swipe-item>
    </van-swipe>

    <!-- 商品名 -->
    <div class="goods-info">
      <div class="goods-price">
        <div class="price">
          <span class="price-icon">¥</span>{{ productInfo.shop_price || 0 | numToCash  }}
          <span class="original-price">市场价¥{{ productInfo.market_price || 0 | numToCash  }}</span>
        </div>
        <div class="sold">已售{{ productInfo.sales_sum }}</div>
      </div>

      <div class="goods-desc-block">
        <div class="goods-name">
          <van-tag color="#ff5000" type="primary" size="medium">推荐</van-tag>
          {{ productInfo.brand_name }}
          {{ productInfo.goods_name }}
        </div>
        <div class="goods-desc">商品编号：{{ productInfo.goods_sn }}</div>
      </div>
    </div>

    <div class="goods-cell">
      <div class="cell-tips">库存</div>
      <div class="cell-center" v-if="productInfo.stock > 0">{{productInfo.stock}}</div>
      <div class="cell-center" v-else>0</div>
    </div>

    <!-- <div class="goods-cell" @click="goExpressRule()"> -->
    <div class="goods-cell" v-if="Number(productInfo.express_price) > 0 ">
      <div class="cell-tips">配送</div>
      <div class="cell-center" > {{ productInfo.express_price }}</div> 
    </div>

    <!-- 
            "goods_name": "商品名称",
             "activity_type": "",
            "goods_sn": "编号",
            "click_count": 点击数,
            "stock": 库存,
            "market_price": "市场价",
            "shop_price": "销售价",
            "express_price": "快递金额",
            "goods_content": "商品内容",
            "pic": "主图",
            "pic_list": 图片列表,
            "sales_sum": 销量,
            "collect_sum": 收藏量
     -->

    <!-- 图片详情 -->
    <div class="goods-title">-商/品/详/情-</div>

    <div class="center-b" v-html="productInfo.goods_content">

    </div>

    <!-- 底部按钮 -->
    <van-goods-action :safe-area-inset-bottom="true">
      <van-goods-action-icon icon="chat-o" text="咨询" @click="onIsChat" />  
      <van-goods-action-button color="#ff5000" type="danger" text="立即购买" @click="goAssociationGoods" />
      <!-- <van-goods-action-button v-if="productInfo.stock > 0" color="#ff5000" type="danger" text="立即购买" @click="goAssociationGoods" />
      <van-goods-action-button v-else color="#ff5000" disabled type="danger" text="库存不足" /> -->
    </van-goods-action>

    <van-popup v-model="isChatPup" position="bottom" round>
      <div class="sku-block">
        <van-field v-model="chatContent" rows="8" autosize label="问题内容" type="textarea" maxlength="200" placeholder="请输入您要咨询的问题。" show-word-limit />
        <div class="sku-btn-block">
          <div class="sku-btn-left btnC" @click="onIsChat()">取 消</div>
          <div class="sku-btn-right btnC" @click="pushChat()">提 交</div>
        </div>
      </div>
    </van-popup>

  </div>
</template>
  
  <script>
  import { ImagePreview } from "vant";
//    this.$router.push({ path: `/product-details/${even.r_id}` });
import imgTextRow from "@/components/img-text-block/img-text-block.vue";
import navbar from "@/components/navbar/navbar.vue";
import sdk from "../../utils/wechart"; //引入sdk.js
export default {
  name: "ProductList",
  components: {
    navbar,
    imgTextRow,
  },
  props: {},
  data() {
    return {
      productId: this.$route.params && this.$route.params.id,
      ass_goods_sku_id: this.$route.params && this.$route.params.skuid,
      productInfo: {},
      isTop: false,
      disabled: false,

      isChatPup: false, // 咨询弹窗
      chatContent: "", //咨询内容
    }; 
  },
  watch: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.getScroll);
    this.init();
    if (!this.isLogin()) return false;
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
  methods: {
    imagePreview(list, index) {
      ImagePreview({
        //图片预览
        images: list, //需要预览的图片 URL 数组
        showIndex: true, //是否显示页码
        loop: false, //是否循环播放
        startPosition: index, //图片预览起始位置索引
        closeable: true, //是否显示关闭图标
        // showIndicators: true, //	是否显示轮播指示器
      });
    },
    // 初始化商品详情数据
    init() {
      let _this = this;
      this.$toast.loading();
      let data = {
        ass_goods_id: _this.productId,
        ass_goods_sku_id: _this.ass_goods_sku_id,
      };
      _this.$post("/api/ass_goods_detail", data, data).then((res) => {
        console.log(res.data);
        if (res.data && res.data.code == 0) {
          // console.log(res.data.data);
          _this.productInfo = res.data.data;

          _this.productInfo.goods_content = _this.formatRichText(
            res.data.data.goods_content
          );

          _this.$toast.clear();
          // _this.getNotice(_this.productId);
          // _this.shareDetail(res.data.data);
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    //监听滚动
    getScroll() {
      this.indexNumTop = $("#page").offset().top;
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //   console.log(window.pageYOffset ||  document.documentElement.scrollTop ||  document.body.scrollTop)
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop >= 200
      ) {
        // 设置滚动大于300时的执行内容
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
    // 返回首页
    goHome() {
      this.$router.replace({
        name: "index",
        query: {},
      });
    },
    //   客服
    onIsChat() {
      this.chatContent = undefined;
      this.isChatPup = !this.isChatPup;
      // this.MakeCall(); //拨打电话
    },
    // 提交咨询
    pushChat() {
      let _this = this;
      let params = {
        goods_id: _this.productId,
        content: _this.chatContent,
      };
      _this.$post("/api/user_consult_add", params, params).then((res) => {
        // console.log(res.data);
        if (res.data.code == 0) {
          _this.$toast.success(res.data.message);
          _this.onIsChat();
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    onClickLeft() {
      let beforeLoginUrl = Lockr.get("beforeLoginUrl")
        ? JSON.parse(Lockr.get("beforeLoginUrl"))
        : "";
      let oldUrl = Lockr.get("oldUrl") ? Lockr.get("oldUrl") : "";

      // console.log(beforeLoginUrl)

      if (!beforeLoginUrl) {
        if (window.history.length <= 1) {
          this.$router.replace({
            name: "index",
            query: {},
          });
          return false;
        } else {
          this.$router.go(-1);
        }
      } else if (
        beforeLoginUrl.name == "product-details" &&
        oldUrl.name == "product-details"
      ) {
        this.$router.replace({
          name: "index",
          query: {},
        });
        // console.log(oldUrl.name)
        // console.log(beforeLoginUrl.name)
      }

      // console.log(window.history.length, 'w')
    },
    // 跳确认订单
    goAssociationGoods() {
      let _this = this;
      if (!this.isLogin()) return false;

   
      let obj = {
        ass_goods_id: _this.productId,
        ass_goods_sku_id: _this.ass_goods_sku_id,
        goods_name: _this.productInfo.goods_name, //商品名称
        activity_type: _this.productInfo.activity_type, // 类型；1普通 2礼券 3积分 4兑换
        express_price: _this.productInfo.express_price, // 快递费
        pic: _this.productInfo.pic, // 主图片
        amount: 1,

        market_price: _this.productInfo.market_price, // 市场价
        shop_price: _this.productInfo.shop_price, // 市场价
        stock: _this.productInfo.stock&&_this.productInfo.stock > 0 ? _this.productInfo.stock : 0 , // 库存
        goods_sn: _this.productInfo.goods_sn || undefined, // 编号
        payType:1, //  
      };

      Lockr.set("associationGoodsInfo", obj);
      this.$router.push({
        name: "association-confirm-order",
        query: {},
      });
    },
    // 分享商品
    shareDetail(Product) {
      let _this = this;
      // console.log(Product.images[0])
      let logo =
        "https://qiniu.zdyxjx.com/v3/pic/f30e30f2205a497f93351666655bc56c.png";
      let menuList = [
        "menuItem:share:qq", //分享到QQ
        "menuItem:share:weiboApp", // 分享到Weibo
        "menuItem:favorite", // 收藏
        "menuItem:share:QZone", // 分享到 QQ 空间
        "menuItem:copyUrl", // 复制链接
        "menuItem:openWithQQBrowser", // 在QQ浏览器中打开
        "menuItem:openWithSafari", // 在Safari中打开
        "menuItem:share:email", // 邮件
        "menuItem:readMode", // 阅读模式
        "menuItem:originPage", // 原网页
      ];
      var url = window.location.href.split("#")[0];

      let params = "?productId=" + Product.id;
      var obj = {
        title: Product.name || "百分百生活馆", //document.title, //分享标题
        desc: Product.description || "莫问前程  只问东西", //分享内容
        linkurl:
          location.protocol +
          "//" +
          location.host +
          "/html/#/product-details" +
          params,
        img: Product.images[0] || logo, //分享内容显示的图片
      };
      sdk.getJSSDK(url, obj, menuList);
    },

    formatRichText(html) {
      /*
       * 处理富文本里的图片宽度自适应
       * 1.去掉img标签里的style、width、height属性
       * 2.img标签添加style属性：max-width:100%;height:auto
       * 3.修改所有style里的width属性为max-width:100%
       * 4.去掉<br/>标签
       * @param html
       * @returns {void|string|*}
       */
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        // match = match
        //   .replace(/src="([^"]+)"/gi, 'src="http://xiche.yiro.top$1"')
        //   .replace(/src='([^']+)'/gi, 'src="http://xiche.yiro.top$1"');
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;"'
      );

      //去除table的宽度
      newContent = newContent.replace(
        /<table[^>]*>/gi,
        function (match, capture) {
          return match.replace(/width=\"(.*)\"/gi, "");
        }
      );

      //去除text-indent
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/text-indent:[^;]+;/gi, "text-indent:0")
            .replace(/text-indent:[^;]+;/gi, "text-indent:0");
          return match;
        }
      );

      return newContent;

      //
    },
  },
};
</script>
  
  <style lang="scss">
// 轮播图 图标颜色
.product-page {
  .van-swipe__indicators {
    .van-swipe__indicator--active {
      background-color: #ff5000 !important;
    }
  }
  .van-stepper {
    .van-stepper__minus {
      color: #ff5000 !important;
      border-color: #ff5000 !important;
    }
    .van-stepper__minus--disabled {
      color: #666666 !important;
      border-color: #666666 !important;
    }
    .van-stepper__plus {
      background-color: #ff5000 !important;
    }
  }
}
</style>
  
  <style lang="scss" scoped>
.mb5 {
  margin-bottom: 5px;
}
.mb15 {
  margin-bottom: 15px;
}
.product-page {
  //   height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 0 0 50px 0;

  //   -webkit-overflow-scrolling: touch;
  //   overflow-x: hidden;
  //   overflow-y: scroll;
  //   -ms-overflow-style: none; /* IE */
  //   scrollbar-width: none; /* Firefox */

  .swiper-block {
    height: 375px;
    width: 100%;
    background-color: #fff;
    .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 150px;
      text-align: center;
      background-color: #fff;

      .swiper-img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .center-b {
    padding: 15px;
    font-size: 13px;
    text-align: left;
    p {
      text-indent: 2em;
    }
    img {
      display: block;
      width: 100%;
    }
  }

  //限时活动
  // .goods-time {
  //   height: 57px;
  //   width: 100%;
  //   padding: 0 10px;
  //   background-image: url("https://qiniu.zdyxjx.com/minizdyxgoods-bg.png");
  //   background-repeat: no-repeat;
  //   background-size: 100% 100%;
  //   background-position: 0 0;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   // background-color: palegreen;
  //   .goods-time-price {
  //     width: 50%;
  //     height: 100%;
  //     text-align: left;
  //     display: flex;

  //     flex-direction: column;
  //     justify-content: space-between;
  //     padding: 5px 0;
  //     //   justify-content: center;
  //     .original-price {
  //       font-size: 14px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 500;
  //       line-height: 17px;
  //       color: #eeeeee;
  //       span {
  //         margin-left: 8px;
  //         text-decoration: line-through;
  //         font-size: 10px;
  //       }
  //     }
  //     .price {
  //       span {
  //         font-size: 12px;
  //       }
  //       font-size: 24px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 500;
  //       // line-height: 30px;
  //       color: #ffffff;
  //       letter-spacing: 1px;
  //     }
  //   }
  //   .goods-time-date {
  //     width: 50%;
  //     height: 100%;
  //     text-align: right;
  //     display: flex;
  //     flex-direction: column;
  //     justify-content: space-between;
  //     padding: 5px 0;

  //     .tips {
  //       margin-bottom: 2px;
  //       font-size: 12px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 500;
  //       line-height: 21px;
  //       color: #ffffff;
  //       letter-spacing: 1px;
  //     }
  //     .colon {
  //       display: inline-block;
  //       margin: 0 4px;
  //       color: #fff;
  //     }
  //     .block {
  //       display: inline-block;
  //       width: 22px;
  //       color: #fff;
  //       font-size: 12px;
  //       text-align: center;
  //       border-radius: 5px;
  //       border: 1px solid #fff;
  //       // background-color: #ee0a24;
  //     }
  //   }
  // }
  //商品名
  .goods-info {
    // min-height: 107px;
    width: 100%;
    padding: 0 15px 15px;
    margin-bottom: 5px;
    //   background-image: url("https://qiniu.zdyxjx.com/minizdyxgoods-bg.png");
    //   background-repeat: no-repeat;
    //   background-size: 100% 100%;
    //   background-position: 0 0;
    background-color: #ffffff;

    .goods-price {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 41px;
      color: #ff5000;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price-icon {
        font-size: 12px;
      }
      .original-price {
        text-decoration: line-through;
        font-size: 12px;
        color: #78849e;
        margin-left: 10px;
      }
      .sold {
        color: #707070;
        font-size: 12px;
      }
    }

    .goods-desc-block {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      // color: #eeeeee;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;

      .goods-name {
        color: #2a2e43;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 30px;
        letter-spacing: 1px;
        text-align: left;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .goods-desc {
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 21px;
        color: #707070;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
    }
  }
  /* cell */
  .mb10 {
    margin-bottom: 10px;
  }
  .goods-cell {
    min-height: 44px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
  }

  .cell-tips {
    width: 15%;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-right: 50rpx; */
  }

  .cell-center {
    width: 80%;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 25px;
    padding-right: 15px;
    color: #2a2e43;
    /* background-color: #fff; */
    display: flex;
    justify-content: start;
    align-items: center;
    // background-image: url("https://qiniu.zdyxjx.com/minizdyxarrow.png");
    // background-repeat: no-repeat;
    // background-size: 5px 10px;
    // background-position: 95% center;
    /* white-space: nowrap; */
    /*内容超宽后禁止换行显示*/
    /* overflow: hidden; */
    /*超出部分隐藏*/
    /* text-overflow: ellipsis; */
    /*文字超出部分以省略号显示*/
    border-bottom: 1px solid #eeeeee;
  }
  .cell-center-n {
    width: 80%;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 25px;
    padding-right: 15px;
    color: #2a2e43;
    /* background-color: #fff; */
    display: flex;
    justify-content: start;
    align-items: center;
    /* white-space: nowrap; */
    /*内容超宽后禁止换行显示*/
    /* overflow: hidden; */
    /*超出部分隐藏*/
    /* text-overflow: ellipsis; */
    /*文字超出部分以省略号显示*/
    border-bottom: 1px solid #eeeeee;
  }
  /* 图片头 */
  .goods-title {
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 25px;
    color: #78849e;
    letter-spacing: 2.5px;
  }
  // 详情图
  .goods-img-d {
    /* background-color: #fff; */
    /* min-height: 500rpx; */
    padding: 0 5px 60px 0;
    box-sizing: border-box;
    width: 100%;
    .img-d {
      display: block;
      width: 100%;
      /* height: 100%; */
    }
  }
}
/* sku弹出框*/
.sku-block {
  height: 100%;
  /* padding: 20rpx 0; */
  min-height: 200px;
  position: relative;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  /* padding-bottom: 100rpx; */
  .sku-center-block {
    height: 340px;
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE */
    scrollbar-width: none; /* Firefox */
    padding: 0 0 100px 0;

    /* 单选 */
    .sku-radio {
      /* background-color: papayawhip; */
      text-align: left;
      padding: 10px;
    }
    .sku-radio-name {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 25px;
      color: #999999;
    }
    .radio {
      min-width: 35px;
      text-align: center;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 25px;
      color: #666666;
      display: inline-block;
      padding: 1px 5px;
      background: #eeeeee;
      border-radius: 5px;
      margin: 5px 10px;
      border: 1px solid #eeeeee;
    }
    .radio-active {
      background: #fff;
      border: 1px solid #ff5000;
      color: #ff5000;
    }

    // 步进器
    .goods-num {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      .num-title {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #999999;
        letter-spacing: 1px;
        span {
          font-size: 12px;
        }
      }
    }
  }

  .sku-header {
    margin-top: 10px;
    height: 125px;
    /* background-color: paleturquoise; */
    display: flex;
    justify-content: start;
    align-items: flex-end;
    padding: 0 10px;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
  }
  .sku-img-block {
    width: 125px;
    height: 125px;
    border-radius: 5px;
  }
  .sku-img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
  }
  .sku-info {
    /* background-color: pink; */
    margin-left: 10px;
    .original-price {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #78849e;
      text-decoration: line-through;
    }
    .sku-price {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #ff5000;
    }
    .sku-desc {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 25px;
      color: #454f63;
    }
  }
  .sku-btn-block {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    height: 47px;
    padding: 0 15px;
    background-color: #ffffff;
    border-top: 1px solid #f9f9f9;

    box-shadow: 0px -5px 5px rgba(69, 79, 99, 0.06);
    display: flex;
    align-items: center;
    justify-content: center;
    .sku-btn-left {
      width: 50%;
      height: 40px;
      background: #ff510093;
      opacity: 1;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sku-btn-right {
      width: 50%;
      height: 40px;
      background: #ff5000;
      opacity: 1;

      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.btn:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
.btnC:active {
  background-color: rgba(58, 204, 225, 0.7) !important;
}
.h-nav-item {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30px;
  height: 30px;
  border-radius: 12px;
  font-size: 15px;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.8;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #eee;
}
</style>
  